var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { GridColumn, EqualHeightProvider, Grid, Spinner, Notice } from 'telia-front-react';
import { FetchStatus } from '../../../util/FetchStatus';
import { TvChannelComparison } from '../channelComparison/TvChannelComparison';
import { TvPackageOfferingCard } from './TvPackageOfferingCard';
import TvPackageStore from '../stores/TvPackageStore';
let tvPackageStore;
let TvPackageOfferingWrapper = class TvPackageOfferingWrapper extends Component {
    constructor(props) {
        super(props);
        if (props.tvPackageStore === undefined) {
            tvPackageStore = new TvPackageStore(props.tier, props.app, props.language);
        }
        else {
            tvPackageStore = props.tvPackageStore;
        }
        tvPackageStore.fetchTvPackages(props.basketId, props.productId, props.selectedCategoryCode);
        tvPackageStore.generateBasketIdAndFetchPackagePrices(props.generateBasketId, props.customerId);
    }
    async componentDidUpdate(prevProps) {
        const { basketId, generateBasketId, productId, selectedCategoryCode, customerId } = this.props;
        if (basketId !== prevProps.basketId && basketId) {
            tvPackageStore.fetchPackagePrices(basketId);
        }
        if (customerId !== prevProps.customerId) {
            tvPackageStore.generateBasketIdAndFetchPackagePrices(generateBasketId, customerId);
        }
        if (productId !== prevProps.productId && productId) {
            tvPackageStore.fetchTvPackages(basketId, productId, selectedCategoryCode);
        }
        if (selectedCategoryCode !== prevProps.selectedCategoryCode) {
            tvPackageStore.fetchTvPackages(basketId, productId, selectedCategoryCode);
        }
    }
    render() {
        const { headingLevel, headingText, tier, language, packageData, isInvalid, variant, viewerSlotIcon, selectedCategoryCode, translate, optionCardProps, breakPoint = 'sm', isTestEnvironment, } = this.props;
        if ([FetchStatus.FETCHING, FetchStatus.UNINITIALIZED].includes(tvPackageStore.status)) {
            return React.createElement(Spinner, null);
        }
        if (tvPackageStore.status === FetchStatus.ERROR) {
            return React.createElement(Notice, { type: 'error' }, translate('general.error.message'));
        }
        const findPackageExtraInfo = (title) => packageData.find((pd) => pd.name === title);
        const packages = tvPackageStore.tvPackageCards
            .filter((p) => { var _a; return !selectedCategoryCode || ((_a = p.categoriesList) === null || _a === void 0 ? void 0 : _a.includes(selectedCategoryCode)); })
            .sort((a, b) => { var _a, _b; return ((_a = findPackageExtraInfo(a.title)) === null || _a === void 0 ? void 0 : _a.order) - ((_b = findPackageExtraInfo(b.title)) === null || _b === void 0 ? void 0 : _b.order); });
        return (React.createElement(React.Fragment, null,
            React.createElement(TvChannelComparison, { headingLevel: headingLevel, defaultSelectedPackage: tvPackageStore.selectedPackage, onClose: () => (tvPackageStore.isModalOpen = false), isOpen: tvPackageStore.isModalOpen, isModal: true, headingText: headingText, tier: tier, language: language, translations: this.props.translations, disableTranslationsStatistics: this.props.disableTranslationsStatistics, isTestEnvironment: isTestEnvironment }),
            React.createElement(EqualHeightProvider, { groups: ['packet-title', 'packet-price'] },
                React.createElement(Grid, { equalHeight: true, align: ['center-xs'] }, packages.map((packet, index) => {
                    var _a;
                    return (React.createElement(GridColumn, { key: index, width: ['xs-12', `${breakPoint}-4`] }, React.createElement(TvPackageOfferingCard, { ...packet,
                        prices: ((_a = tvPackageStore.customerPrices) === null || _a === void 0 ? void 0 : _a.length)
                            ? tvPackageStore.customerPrices.find((price) => price.name === packet.prices.name)
                            : packet.prices, openModal: (newPackage) => {
                            tvPackageStore.isModalOpen = true;
                            tvPackageStore.selectedPackage = newPackage;
                        }, index: index, isExistingOffering: packet.title === tvPackageStore.existingPackage, isInvalid: isInvalid, tagsTop: findPackageExtraInfo(packet.title).tagsTop, url: findPackageExtraInfo(packet.title).url, channelsAmount: findPackageExtraInfo(packet.title).channelsAmount || packet.channels, variant: variant || 'dark', optionCardProps: optionCardProps, headingLevel: headingLevel, icon: viewerSlotIcon || '#tv-viewslot', additionalServicesFromProps: findPackageExtraInfo(packet.title).additionalServicesFromProps, teliaWebSelfServiceUrl: tvPackageStore.selfServiceUrl, translate: translate, displayCampaign: this.props.displayCampaign })));
                })))));
    }
};
TvPackageOfferingWrapper = __decorate([
    observer
], TvPackageOfferingWrapper);
export { TvPackageOfferingWrapper };
